import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const postSyncSupplierInvoicesFromFortnox = (
    token: string,
    backend: string,
    financialYearDate,
    created_by_id
) => {
    return fetch(
        `${getApiUrl(backend)}import_fortnox_supplier_invoices`,
        {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                filter: financialYearDate,
                created_by_id
            })
        }
    );
};

export default postSyncSupplierInvoicesFromFortnox;
